import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootDispatch, RootState } from "../../store";
import { resendWarrantyDetails } from "../../store/slices/productSlice";
import { toast } from "react-toastify";

interface ResendModalProps {
  isOpen: boolean;
  onClose: () => void;
  warrantyId: string;
}

const ResendModal: React.FC<ResendModalProps> = ({
  isOpen,
  onClose,
  warrantyId,
}) => {
  const dispatch: RootDispatch = useDispatch();
  const loading = useSelector((state: RootState) => state.product.loading);
  const [mobileNumber, setMobileNumber] = useState("");

  const handleResend = async () => {
    if (!warrantyId) return;
    try {
      const response = await dispatch(
        resendWarrantyDetails({
          id: warrantyId,
          mobileNumber: mobileNumber || undefined,
        })
      ).unwrap();
      if (response.message) toast.success(response.message);
      onClose();
    } catch (err: any) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    if (!isOpen) setMobileNumber("");
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-4 rounded shadow w-80">
        <h2 className="font-semibold mb-2 text-sm">Resend Warranty Details</h2>
        <input
          type="text"
          placeholder="Optional mobile number"
          value={mobileNumber}
          onChange={(e) => setMobileNumber(e.target.value)}
          className="w-full border px-2 py-1 rounded mb-3 text-sm"
          disabled={loading}
        />
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-3 py-1.5 text-sm rounded bg-gray-200 hover:bg-gray-300"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={handleResend}
            className="px-3 py-1.5 text-sm rounded bg-blue-600 text-white hover:bg-blue-700"
            disabled={loading}
          >
            {loading ? "Sending..." : "Resend"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResendModal;
